
import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { DimssaButton, ButtonState } from "@/components/dimssa-button.vue"
import * as Models from "@gigalot/data-models"
import store, { mapFields, mapMultiRowFields } from "@/store"
import lodash from "lodash"
import * as helpers from "@/helpers"
import { downloadObjectAsJson, downloadObjectAsText } from "@/helpers/download"
import { camelCase, getProjectId } from "@/helpers"
import { mqttDeviceId, mqttDeviceRegistryId, mqttPrivateKey, mqttPushCertificate, mqttRegisterDevice } from "@/helpers/mqtt"
import { getGcp } from "@gigalot/utils"
import { updateHoldingCompany } from "@/helpers/graphql"
import JSZip from "jszip"
import { createServiceAccount } from "@/helpers/index"
import { eXgetGcp } from "@/helpers/index"
import { MqttDeviceStatus } from "@/components/MqttDeviceStatus.vue"
import { configFileProxyHandHeldScanner } from "@/helpers/config-generator"

@Component({
  components: {
    DimssaButton,
    MqttDeviceStatus,
  },
  computed: {
    ...mapFields(["handHeldScanner.description"]),
  },
})
export default class HandHeldScanner extends Vue {
  saveButtonState: ButtonState = "ready"

  mqttDevice = {}

  created() {
    this.mqttDevice = {
      id: this.mqttDeviceId(),
      registry: "Handheld_Scanners",
      state: undefined,
    }
  }

  mqttDeviceId() {
    const what: string = "hand-held-scanner"
    const feedlot: Models.Feedlot = this.$store.getters["getField"]("feedlot") as Models.Feedlot
    let handHeldScanners: Models.HandHeldScanner[] = feedlot.handHeldScanners
    let index = handHeldScanners.findIndex((gs) => gs.guid === this.handHeldScanner.guid)
    let num = index + 1
    if (index < 0) {
      //user might be busy with a new hand held scanner that has not been saved yet.
      num = handHeldScanners.length + 1
    }
    return mqttDeviceId(what, this.getGcp(), this.getGuid(), num)
  }

  get handHeldScanner(): Models.HandHeldScanner {
    return this.$store.getters["getField"]("handHeldScanner")
  }
  get serviceAccountName() {
    return `${eXgetGcp().slice(0, 29)}`
  }
  async save() {
    try {
      this.saveButtonState = "busy"
      const holdingCompany: Models.HoldingCompany = this.$store.getters["getField"]("holdingCompany") as Models.HoldingCompany
      const feedlot: Models.Feedlot = this.$store.getters["getField"]("feedlot") as Models.Feedlot
      if (!feedlot.handHeldScanners) feedlot.handHeldScanners = []
      helpers.addToListGuids(feedlot.handHeldScanners, this.handHeldScanner)
      helpers.addToListGuids(holdingCompany.feedlots, feedlot)
      this.$store.commit("updateField", { path: "feedlot", value: feedlot })
      await updateHoldingCompany(holdingCompany)
      this.saveButtonState = "success"
    } catch (err) {
      console.error(`Error saving Hand Held Scanner`)
      console.error(err)
      this.saveButtonState = "error"
    }
  }

  configFile(download = true) {
    let json = configFileProxyHandHeldScanner({ mqttDeviceId: this.mqttDeviceId() })
    if (download) downloadObjectAsJson(json, "config")
    return json
  }

  getGuid() {
    const feedlot: Models.Feedlot = this.$store.getters["getField"]("feedlot") as Models.Feedlot
    return feedlot.guid
  }

  getGcp() {
    const feedlot: Models.Feedlot = this.$store.getters["getField"]("feedlot") as Models.Feedlot
    let holdingCompany = this.$store.getters["getField"]("holdingCompany")
    return getGcp(feedlot, holdingCompany)
  }

  async createServiceAccount(download = true) {
    try {
      let data = await createServiceAccount(this.serviceAccountName, download)
      return data
    } catch (err) {
      console.log("error: " + err)
      throw err
    }
  }

  async downloadArchive() {
    var zip = new JSZip()

    zip.file("service-account.json", await this.createServiceAccount(false))
    //zip.file("mqtt.pem", await this.mqttPrivateKey(false));
    zip.file("config.json", JSON.stringify(this.configFile(false)))

    zip.generateAsync({ type: "blob" }).then(function (content) {
      var downloadAnchorNode = document.createElement("a")

      let dataURL = (window.URL || window.webkitURL).createObjectURL(content)
      downloadAnchorNode.setAttribute("href", dataURL)
      downloadAnchorNode.setAttribute("download", `archive.zip`)
      document.body.appendChild(downloadAnchorNode) // required for firefox
      downloadAnchorNode.click()
      downloadAnchorNode.remove()
    })
  }
}
